module.exports = __webpack_public_path__ + "static/media/nebula_apps2(1).27c3f772.png";